import * as React from 'react'
import { Avatar, List, ListItem, ListItemAvatar, ListItemText, DialogTitle, Dialog } from '@mui/material'
import PersonIcon from '@mui/icons-material/Person'
import { blue } from '@mui/material/colors'
import { Trans } from '@lingui/macro'

import { ChatMessage, ChatRoom } from '@/core/models/chat-room.model'
import { getUserName } from './Message'

export interface MessageReadersBoxProps {
  open: boolean
  onClose: () => void
  message: ChatMessage
  chatRoomUsers?: ChatRoom['users']
}

export default function MessageReadersBox({ open, onClose, message, chatRoomUsers }: MessageReadersBoxProps) {
  const readers = message.readBy.filter((userId) => userId !== message.author)

  const handleClose = () => {
    onClose()
  }

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>
        <Trans>Message readers</Trans>
      </DialogTitle>
      <List sx={{ pt: 0, ml: 3, minWidth: 300, maxHeight: '300px', overflow: 'auto' }}>
        {readers.map((userId) => {
          const userName = getUserName(userId, chatRoomUsers, true)
          return (
            <ListItem disableGutters key={userId} >
              <ListItemAvatar>
                <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                  <PersonIcon />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={userName} />
            </ListItem>
          )
        })}
      </List>
    </Dialog>
  )
}
